import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_EQUIPMENT_CONSTANT } from '_api/queries';
import { ConstantsIdTitle } from '_api/types';

export const CREATE_EQUIPMENT_CONSTANT = 'create-equipment-constant';

export const useCreateEquipmentConstant = () => {
  const queryClient = useQueryClient();
  return useApiMutation<ConstantsIdTitle, { title: string }>(
    () => '/constant/create-equipment',
    'post',
    {},
    {
      mutationKey: [CREATE_EQUIPMENT_CONSTANT],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_EQUIPMENT_CONSTANT] });
      },
    },
    (body) => JSON.stringify(body),
  );
};
